import http from '../http'
import * as types from '../mutation-types';

export const state = {
    status: '',
    skills: null,
    list: null,
};

export const getters = {
    loadStatus: state => state.status,
    skills: state => state.skills,
    list: state => state.list
};

export const mutations = {
    /** LOAD */
    [types.LOAD_SKILLS_LOADING](state) {
        state.status = 'loading'
    },
    [types.LOAD_SKILLS_SUCCESS](state, {data, meta}) {
        state.status = 'success'
        state.skills = data
    },
    [types.LOAD_SKILLS_ERROR](state) {
        state.status = 'error'
    },
    /** LIST */
    [types.LIST_SKILLS_LOADING](state) {
        state.status = 'loading'
    },
    [types.LIST_SKILLS_SUCCESS](state, {data, meta}) {
        state.status = 'success'
        state.list = data
    },
    [types.LIST_SKILLS_ERROR](state) {
        state.status = 'error'
    },
};

export const actions = {
    load({commit}) {
        return new Promise((resolve, reject) => {
            commit(types.LOAD_SKILLS_LOADING);
            http.get('skills').then(({data}) => {
                commit(types.LOAD_SKILLS_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.LOAD_SKILLS_ERROR)
                reject(response.data)
            })
        })
    },
    list({commit}) {
        return new Promise((resolve, reject) => {
            commit(types.LIST_SKILLS_LOADING);
            http.get('skills/grouped-category').then(({data}) => {
                commit(types.LIST_SKILLS_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.LIST_SKILLS_ERROR)
                reject(response.data)
            })
        })
    }
};
